<template>
  <div>
    <div class="detial-cont-title">申请表单</div>
    <blank height="1"> </blank>
    <div class="detial-cont-view">
      <a-descriptions layout="vertical">
        <a-descriptions-item label="申请部门/单位">
          <a-tooltip placement="topLeft" :title="Form.organizationName">
            <div>
              <a-input
                v-if="Form.id"
                class="w300"
                placeholder="请添加"
                v-model="Form.organizationName"
                disabled
              />
              <a-select
                v-else
                class="w300"
                placeholder="请选择"
                v-model="Form.organizationId"
                :disabled="disabled"
              >
                <a-select-option
                  v-for="item in organizationUserList"
                  :value="item.organizationId"
                  :key="item.organizationId"
                >
                  {{ item.organizationname }}</a-select-option
                >
              </a-select>
            </div>
          </a-tooltip>
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">资产名称<span class="required">*</span> </span>
          <a-input
            class="w300"
            placeholder="请输入资产名称"
            v-model="Form.assetsname"
            @change="emitDataFn('assetsname', 85)"
            :disabled="disabled"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label"
            >账面原值（元）<span class="required">*</span>
          </span>
          <a-input-number
            :min="0"
            :max="9999999999"
            class="w300"
            placeholder="请输入账面原值"
            v-model="Form.storage"
            @change="emitDataFn()"
            :disabled="disabled"
          />
        </a-descriptions-item>
        <a-descriptions-item label="购建时间">
          <a-date-picker
            class="w300"
            v-model="Form.buildtime"
            @change="emitDataFn()"
            :disabled="disabled"
            :valueFormat="dayFormat"
          />
        </a-descriptions-item>
        <a-descriptions-item label="规格型号">
          <a-input
            class="w300"
            placeholder="请输入规格型号"
            v-model="Form.model"
            @change="emitDataFn('model', 85)"
            :disabled="disabled"
          />
        </a-descriptions-item>
        <a-descriptions-item label="已提折旧 (元)">
          <a-input-number
            :min="0"
            :max="99999999999"
            class="w300"
            placeholder="请输入"
            v-model="Form.depreciation"
            @change="emitDataFn()"
            :disabled="disabled"
          />
        </a-descriptions-item>
        <a-descriptions-item label="计划使用年限">
          <a-input-number
            :min="0"
            :max="999999999"
            class="w300"
            placeholder="请输入"
            v-model="Form.plannedlife"
            @change="emitDataFn()"
            :disabled="disabled"
          />
        </a-descriptions-item>
        <a-descriptions-item label="单价(元)">
          <a-input-number
            :min="0"
            :max="9999999999"
            class="w300"
            placeholder="请输入"
            v-model="Form.unitprice"
            @change="emitDataFn()"
            :disabled="disabled"
          />
        </a-descriptions-item>
        <a-descriptions-item label="净值（元）">
          <a-input-number
            :min="0"
            :max="9999999999"
            class="w300"
            placeholder="请输入"
            v-model="Form.networth"
            @change="emitDataFn()"
            :disabled="disabled"
          />
        </a-descriptions-item>
        <a-descriptions-item label="已使用年限">
          <a-input-number
            :min="0"
            :max="999999999"
            class="w300"
            placeholder="请输入"
            v-model="Form.usefullife"
            @change="emitDataFn()"
            :disabled="disabled"
          />
        </a-descriptions-item>
        <a-descriptions-item label="数量">
          <a-input-number
            :min="0"
            :max="999999999"
            class="w300"
            placeholder="请输入"
            v-model="Form.count"
            @change="emitDataFn()"
            :disabled="disabled"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label"
            >预计残值（元）<span class="required">*</span>
          </span>
          <a-input-number
            :min="0"
            :max="9999999999"
            class="w300"
            placeholder="请输入"
            v-model="Form.amount"
            @change="emitDataFn()"
            :disabled="disabled"
          />
        </a-descriptions-item>
        <a-descriptions-item>
          <span slot="label">处置形式<span class="required">*</span> </span>
          <a-select
            class="w300"
            placeholder="请添加"
            v-model="Form.disposalstate"
            @change="emitDataFn()"
            :disabled="disabled"
          >
            <a-select-option
              v-for="item in dasset_typeList"
              :value="item.valuename"
              :key="item.id"
            >
              {{ item.keyname }}</a-select-option
            >
          </a-select>
        </a-descriptions-item>
        <a-descriptions-item label="备注">
          <a-input
            class="w300"
            placeholder="请输入备注"
            v-model="Form.cause"
            @change="emitDataFn('cause', 200)"
            :disabled="disabled"
          />
        </a-descriptions-item>
        <br />
        <a-descriptions-item label="处置原因">
          <a-input
            class="w500"
            placeholder="请输入处置原因"
            v-model="Form.reason"
            type="textarea"
            @change="emitDataFn('reason', 200)"
            :auto-size="{ minRows: 4, maxRows: 6 }"
            :disabled="disabled"
          />
        </a-descriptions-item>
      </a-descriptions>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { formatDateNoDetails } from '@/assets/js/auth'
export default {
  props: ['disabled', 'resData', 'submitParams'],
  model: {
    prop: 'submitParams',
    event: 'input'
  },
  data() {
    return {
      Form: {},
      dayFormat: 'YYYY-MM-DD'
    }
  },
  computed: {
    ...mapState({
      organizationUserList: (state) => state.app.organizationUserList, // 当前用户可选部门
      dasset_typeList: (state) => state.bytype.dasset_typeList
    })
  },
  methods: {
    ...mapActions(['getorganizationUserList', 'getdasset_type']),
    handleChange() {
      this.emitDataFn()
    },
    // 传值给父组件
    emitDataFn(v, maxNum) {
      if (v) {
        this.eightyfive(v, maxNum)
      }
      this.$emit('input', this.Form)
    },
    // 输入框限制85
    eightyfive(v, maxNum) {
      if (this.Form[v].length > maxNum) {
        this.Form[v] = this.Form[v].substring(0, maxNum)
        this.$message.destroy()
        this.$message.warning('只能输入' + maxNum + '个字')
      }
    }
  },
  watch: {
    resData(val) {
      this.Form = this.resData
    }
  },
  mounted() {
    //获取组织机构
    this.getorganizationUserList()
    // 获取处置类型字典表
    this.getdasset_type()
    if (this.resData) {
      this.Form = this.resData
    }
  }
}
</script>
<style scoped lang="scss">
.detial-cont-title {
  background: #fff;
  height: 55px;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  line-height: 55px;
  text-align: left;
  padding-left: 32px;
}
.detial-cont-view {
  background: #fff;
  padding: 30px;
  .accessory-btn {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.detial-bottom {
  height: 56px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/views/FixedAssets/components/dispositionDetailForm.vue